import { Component, ElementRef, ViewChild, Input, OnInit } from '@angular/core';
import { BlobUploadsViewStateService } from '../services/blob-uploads-view-state.service';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-input-file',
  template: `
    <input
      style="display: none"
      type="file"
      #fileInput
      multiple="multiple"
      (change)="onSelected($event.target.files)"
    />
    <button *ngIf="!ConsultarShow && globals.lenguaje" class="boton secondary-button" (click)="showFileDialog()">Cargar documento</button>
    <button *ngIf="!ConsultarShow && !globals.lenguaje" class="boton secondary-button" (click)="showFileDialog()">Upload document</button>
    <br *ngIf="!ConsultarShow && errores" />
    <br *ngIf="!ConsultarShow && errores" />
    <div *ngIf="!ConsultarShow && errores">
      <span *ngFor="let mensaje of mensajes" class="border-error-text"><strong>{{mensaje}}</strong></span>
    </div>
  `
})
export class InputFileComponent implements OnInit {  

  @Input()
  ConsultarShow: boolean;

  public lenguajeGlobal;

  errores: boolean = false;
  mensajes: string[] = [];

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef<
    HTMLInputElement
  >;

  constructor(private blobState: BlobUploadsViewStateService, private globals: Globals, private cookies: CookieService) {

    if (this.globals.path == "portal-back") {
      var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
      this.lenguajeGlobal = lenguajeFuncionario;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
    else {
      var lenguajeTurista = this.cookies.get("lenguajeTurista");
      this.lenguajeGlobal = lenguajeTurista;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
  }
  ngOnInit() {
    if (this.globals.path == "portal-back") {
      var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
      this.lenguajeGlobal = lenguajeFuncionario;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
    else {
      var lenguajeTurista = this.cookies.get("lenguajeTurista");
      this.lenguajeGlobal = lenguajeTurista;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
  }

  onSelected(files: FileList): void {
    if (this.mensajes.length > 0) {
      for (let i = 0; i < this.mensajes.length; i++) {
        this.mensajes.pop();
      }
      this.errores = false;
    }
    
    for (let i = 0; i < files.length; i++) {
      var tipo = files.item(i).type;
      if (tipo != "application/pdf") {
        this.mensajes.push("El archivo " + files.item(i).name + " no tiene el formato correcto. Vuelva a intentarlo.")
      }
      else {
        var size = files.item(i).size / 1024 / 1024;
        if (size > 5) {
          this.mensajes.push("El archivo " + files.item(i).name + " excede el tamaño permitido (5MB). Vuelva a intentarlo.")
        }
      }      
    }

    if (this.mensajes.length == 0) {
      this.blobState.uploadItems(files);
      this.fileInput.nativeElement.value = '';
    }
    else {
      this.errores = true;
    }

    if (this.globals.path == "portal-back") {
      var lenguajeFuncionario = this.cookies.get("lenguajeFuncionario");
      this.lenguajeGlobal = lenguajeFuncionario;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
    else {
      var lenguajeTurista = this.cookies.get("lenguajeTurista");
      this.lenguajeGlobal = lenguajeTurista;
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.globals.lenguaje = true;
      } else {
        this.globals.lenguaje = false;
      }
    }
  }

  showFileDialog(): void {
    //this.globals.verarchivos = true;
    this.fileInput.nativeElement.click();
  }
}
